export const NormalizeEmail = (email: string): string => email?.trim().toLowerCase() ?? '';
